import { Controller } from "@hotwired/stimulus"

// Shows/hides a panel based on which radio in a group (rendered by
// FormInputComponent type: :boolean) is currently checked.
// Usage: data-controller="radio-reveal" data-radio-reveal-reveal-when-value="true"
// on a wrapper around both the radio group and the panel; radios need
// data-action="change->radio-reveal#sync"; panel needs
// data-radio-reveal-target="panel".
export default class extends Controller {
  static targets = ["panel"]
  static values = { revealWhen: String }

  connect() {
    this.sync()
  }

  sync() {
    if (!this.hasPanelTarget) return

    const checked = this.element.querySelector("input[type=radio]:checked")
    const show = checked?.value === this.revealWhenValue

    this.panelTarget.classList.toggle("hidden", !show)
  }
}
